import { memo } from "react";

import { useTransferPopup } from "@/hooks/use-transfer-popup";
import { cn } from "@/lib/utils";

import { TransferPopup } from "./TransferPopup";
import type { IFloatingTransferPopupProps } from "./types";
import { ETransferPopupVariant } from "./types";

// NOTE: NSAI-7067 — the card on every page with no chat composer to dock
// above: it floats in the bottom end corner of the content area. Stands down while a dock is mounted,
// so there is never more than one card.
const FloatingTransferPopupComponent = ({
  isRaised,
}: IFloatingTransferPopupProps): JSX.Element | null => {
  const { dockCount } = useTransferPopup();

  if (dockCount > 0) {
    return null;
  }

  return (
    <div
      className={cn(
        "pointer-events-none absolute end-4 z-40 flex max-w-[calc(100%-2rem)] justify-end sm:end-6 sm:max-w-[calc(100%-3rem)] [&>*]:pointer-events-auto",
        // NOTE: bottom-10 clears the copyright line AppLayout overlays on
        // the same corner (12px up, 16px tall).
        isRaised ? "bottom-24" : "bottom-8 sm:bottom-10",
      )}
      data-testid="transfer-popup-floating"
    >
      <TransferPopup variant={ETransferPopupVariant.FLOATING} />
    </div>
  );
};

export const FloatingTransferPopup = memo(FloatingTransferPopupComponent);
